import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { QuizQuestionType } from "@/models/quiz.model";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import PollQuizStatistics from "@/components/quiz/PollQuizStatistics.vue";
let PollQuiz = class PollQuiz extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "pollResultsId", void 0);
    _defineProperty(this, "quizStatisticsData", null);
    _defineProperty(this, "userAnswersIds", null);
    _defineProperty(this, "isSpeachTemplate", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "canEdit", void 0);
    _defineProperty(this, "userRealtimeAnswersIds", null);
  }
  mounted() {
    this.userRealtimeAnswersIds = this.userAnswersIds;
  }
  get userAnswers() {
    return question => {
      if (this.userRealtimeAnswersIds?.length) {
        return question.type === QuizQuestionType.QUESTION_CHOIX_MULTIPLE ? this.userRealtimeAnswersIds : this.userRealtimeAnswersIds[0];
      }
      return null;
    };
  }
  onSelectionChange(selected) {
    this.userRealtimeAnswersIds = Array.isArray(selected) ? selected : [selected];
    this.emitQuizAnswers();
  }
  emitQuizAnswers() {
    return this.userRealtimeAnswersIds;
  }
};
__decorate([Prop({
  required: true
})], PollQuiz.prototype, "question", void 0);
__decorate([Prop({
  default: 0
})], PollQuiz.prototype, "pollResultsId", void 0);
__decorate([Prop], PollQuiz.prototype, "quizStatisticsData", void 0);
__decorate([Prop], PollQuiz.prototype, "userAnswersIds", void 0);
__decorate([Prop({
  default: false
})], PollQuiz.prototype, "isSpeachTemplate", void 0);
__decorate([Prop({
  default: false
})], PollQuiz.prototype, "isResultMode", void 0);
__decorate([Prop({
  default: false
})], PollQuiz.prototype, "canEdit", void 0);
__decorate([Emit('answerChange')], PollQuiz.prototype, "emitQuizAnswers", null);
PollQuiz = __decorate([Component({
  components: {
    PollQuizStatistics,
    QuizQuestionLabel,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], PollQuiz);
export default PollQuiz;